// extracted by mini-css-extract-plugin
module.exports = {"center_container":"Home_center_container__b6hSK"};